<template>
  <div>
    <!-- Floating Chat Icon -->
    <transition name="chat-fade">
      <div v-if="!isOpen" class="chatbot-fab bgcolor-primary" @mouseenter="showPreview = true" @mouseleave="showPreview = false" @click="openChat">
        <img src="../../../../images/ai_agent.png" alt="Chat Icon" class="ai-chat-icon" />
        <transition name="chat-slide">
          <div v-if="showPreview" class="chatbot-preview bgcolor-primary text-white">Ask Vehicle Ai</div>
        </transition>
      </div>
    </transition>

    <!-- Chatbot Modal -->
    <transition name="chat-modal">
      <div v-if="isOpen" class="chatbot-modal" :class="{ 'chatbot-modal-max': isMaximized }">
        <div class="chatbot-header bgcolor-primary">
            <div>
                <div class="font-weight-bold">VehicleIQ</div>
                <div class="ft-12 font-weight-normal">Smarter questions = Own Sharper vehicles</div>
            </div>
            <div class="d-flex align-items-center justify-content-center" style="gap:10px">
                <button class="chatbot-maximize" @click="toggleMaximize" :title="isMaximized ? 'Minimize' : 'Maximize'">
                    <span v-if="!isMaximized">
                        <!-- Generated by IcoMoon.io -->
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="#FFFFFF" d="M8 2h-3c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v3c0 0.552 0.448 1 1 1s1-0.448 1-1v-3c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293h3c0.552 0 1-0.448 1-1s-0.448-1-1-1zM22 8v-3c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879h-3c-0.552 0-1 0.448-1 1s0.448 1 1 1h3c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707v3c0 0.552 0.448 1 1 1s1-0.448 1-1zM16 22h3c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-3c0-0.552-0.448-1-1-1s-1 0.448-1 1v3c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-3c-0.552 0-1 0.448-1 1s0.448 1 1 1zM2 16v3c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h3c0.552 0 1-0.448 1-1s-0.448-1-1-1h-3c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-3c0-0.552-0.448-1-1-1s-1 0.448-1 1z"></path>
                        </svg>
                    </span>
                    <span v-else>
                        <!-- Generated by IcoMoon.io -->
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="#FFFFFF" d="M7 3v3c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-3c-0.552 0-1 0.448-1 1s0.448 1 1 1h3c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-3c0-0.552-0.448-1-1-1s-1 0.448-1 1zM21 7h-3c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-3c0-0.552-0.448-1-1-1s-1 0.448-1 1v3c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h3c0.552 0 1-0.448 1-1s-0.448-1-1-1zM17 21v-3c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293h3c0.552 0 1-0.448 1-1s-0.448-1-1-1h-3c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v3c0 0.552 0.448 1 1 1s1-0.448 1-1zM3 17h3c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707v3c0 0.552 0.448 1 1 1s1-0.448 1-1v-3c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879h-3c-0.552 0-1 0.448-1 1s0.448 1 1 1z"></path>
                        </svg>

                    </span>
                </button>
                <button class="chatbot-close" @click="closeChat">&times;</button>
            </div>
        </div>
        <div class="chatbot-body" ref="chatBody">
          <div v-for="(msg, idx) in messages" :key="idx" :class="['chat-msg', msg.role]">
            <template v-if="msg.type === 'text'">
              <span v-html="msg.content" style="white-space: pre-line;"></span>
            </template>
            <template v-else-if="msg.type === 'table'">
              <div class="chat-table-wrapper">
                <table class="chat-table">
                  <thead>
                    <tr>
                      <th v-for="(col, i) in msg.columns" :key="i">{{ col }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in msg.rows" :key="i">
                      <td v-for="(cell, j) in row" :key="j">{{ cell }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
          <div v-if="isLoading" class="chat-loading">Pulling up your vehicle details now. One sec!</div>
        </div>
        <form class="chatbot-input" @submit.prevent="sendMessage">
          <input v-model="userInput" :disabled="isLoading" placeholder="Type your message..." autocomplete="off" />
          <button type="submit" class="bgcolor-primary" :disabled="isLoading || !userInput.trim()">Send</button>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { ref, reactive, nextTick, onMounted } from 'vue';

export default {
  name: 'ChatBot',
  setup() {
    const isOpen = ref(false);
    const showPreview = ref(false);
    const userInput = ref('');
    const isLoading = ref(false);
    const isMaximized = ref(false);
    const messages = reactive([
      { role: 'bot', type: 'text', content: "Welcome! Ready to find your perfect dream vehicle and make it yours? Just ask me — I'll handle the rest." }
    ]);
    const chatBody = ref(null);

    function openChat() {
      isOpen.value = true;
      showPreview.value = false;
      nextTick(() => {
        scrollToBottom();
      });
    }
    function closeChat() {
      isOpen.value = false;
      userInput.value = '';
    }
    function scrollToBottom() {
      nextTick(() => {
        if (chatBody.value) {
          chatBody.value.scrollTop = chatBody.value.scrollHeight;
        }
      });
    }
    function toggleMaximize() {
      isMaximized.value = !isMaximized.value;
      nextTick(() => {
        if (chatBody.value) {
          chatBody.value.scrollTop = chatBody.value.scrollHeight;
        }
      });
    }    
    async function sendMessage() {
      if (!userInput.value.trim()) return;
      messages.push({ role: 'user', type: 'text', content: userInput.value });
      isLoading.value = true;
      const input = userInput.value;
      userInput.value = '';
      scrollToBottom();
        try {
        const response = await axios.get(
            `${window.ApiBaseUrl}/Vehicles/comparevehicles?dealerId=${window.accountId}&userQuery=${input}`
        );
        const data = response.data;
        // Handle both plain text and table responses
        if (data.type === 'table') {
            messages.push({ role: 'bot', type: 'table', columns: data.columns, rows: data.rows });
        } else {
            messages.push({ role: 'bot', type: 'text', content: data });
        }
        } catch (e) {
        messages.push({
            role: 'bot',
            type: 'text',
            content: "I couldn't find an answer at the moment. Want to try a different question?"
        });
        } finally {
        isLoading.value = false;
        scrollToBottom();
        }
    }
    
    onMounted(() => {
      setTimeout(() => {
        isOpen.value = true;
      }, 2000);
    });

    return {
      isOpen,
      showPreview,
      userInput,
      isLoading,
      isMaximized,
      messages,
      chatBody,
      openChat,
      closeChat,
      toggleMaximize,
      sendMessage
    };
  }
};
</script>

<style scoped>
.chatbot-fab {
  position: fixed;
  bottom: 32px;
  left: 32px;
  /* right: 32px; */
  width: 125px;
  height: 125px;  
  border-radius: 50%;  
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2000;
  transition: box-shadow 0.2s;
}
.chatbot-fab:hover {
  box-shadow: 0 8px 32px rgba(0,0,0,0.28);
}
.primaryicon-Chat-Icon {
  font-size: 32px;
  color: #fff;
}
.chatbot-preview {
  position: absolute;
  left: 135px;
  /* right: 70px; */
  bottom: 40px;
  padding: 8px 18px;
  border-radius: 18px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  font-size: 16px;
  white-space: nowrap;
  animation: fadeIn 0.3s;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.chatbot-modal {
  position: fixed;
  bottom: 32px;
  left: 32px;
  /* right: 32px; */
  width: 450px;
  max-width: 95vw;
  height: 80vh;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.22);
  display: flex;
  flex-direction: column;
  z-index: 2100;
  animation: chatOpen 0.4s cubic-bezier(.4,1.4,.6,1);
  transition: width 0.3s, height 0.3s;
}
.chatbot-modal-max {
  width: 90vw !important;
  height: 90vh !important;
  max-width: 1200px !important;
  max-height: 98vh !important;
  left: 50%;
  top: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
}
.chatbot-header {
  color: #fff;
  padding: 15px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chatbot-maximize {
  background: none;
  border: none;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  vertical-align: middle;
  outline: none !important;
}
.chatbot-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 26px;
  cursor: pointer; 
  outline: none !important; 
}
.chatbot-body {
  flex: 1;
  overflow-y: auto;
  padding: 18px 16px 10px 16px;
  background: #f7f8fa;
  display: flex;
  flex-direction: column;
}
.chat-msg {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  max-width: 90%;
}
.chat-msg.user {
  align-self: flex-end;
  background: #e6f0ff;
  color: #333;
  border-radius: 12px 12px 2px 12px;
  padding: 10px 14px;
  box-shadow: 0 2px 8px rgba(79,140,255,0.08);
}
.chat-msg.bot {
  align-self: flex-start;
  background: #fff;
  color: #222;
  border-radius: 12px 12px 12px 2px;
  padding: 10px 14px;
  box-shadow: 0 2px 8px rgba(111,111,255,0.08);
}
.chat-table-wrapper {
  overflow-x: auto;
  margin: 8px 0;
}
.chat-table {
  border-collapse: collapse;
  width: 100%;
  background: #fff;
}
.chat-table th, .chat-table td {
  border: 1px solid #e0e0e0;
  padding: 6px 10px;
  font-size: 14px;
}
.chatbot-input {
  display: flex;
  padding: 12px 16px;
  border-top: 1px solid #eee;
  background: #fafbfc;
}
.chatbot-input input {
  flex: 1;
  border: none;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 15px;
  margin-right: 10px;
  background: #f1f3f7;
  outline: none;
}
.chatbot-input button {  
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s;
}
.chatbot-input button:disabled {
  background: #bfc6d1;
  cursor: not-allowed;
}
.chat-loading {
  color: #888;
  font-style: italic;
  margin: 10px 0 0 0;
  text-align: center;
}

/* Animations */
.chat-fade-enter-active, .chat-fade-leave-active {
  transition: opacity 0.3s;
}
.chat-fade-enter-from, .chat-fade-leave-to {
  opacity: 0;
}
.chat-slide-enter-active, .chat-slide-leave-active {
  transition: transform 0.2s, opacity 0.2s;
}
.chat-slide-enter-from, .chat-slide-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
.chat-modal-enter-active, .chat-modal-leave-active {
  transition: opacity 0.4s, transform 0.4s;
}
.chat-modal-enter-from, .chat-modal-leave-to {
  opacity: 0;
  transform: scale(0.8);
}
.ai-chat-icon{
  max-width: 70%;
  height: auto;
}
</style>
